export default "__VITE_ASSET__599a08b1__"